<template>
  <body class="body">
    <div class="container" id="formContent">
        <div v-if="$route.params.class == 5">
          <img style="width: 70%;" src="../img/clasa_5.png"/>
        </div>

        <div v-if="$route.params.class == 6">
          <img style="width: 70%;" src="../img/clasa_6.png"/>
        </div>

        <div v-if="$route.params.class == 7">
          <img style="width: 70%;" src="../img/clasa_7.png"/>
        </div>

        <div v-if="$route.params.class == 8">
          <img style="width: 70%;" src="../img/clasa_8.png"/>
        </div>

        <vue-custom-scrollbar class="scroll-area">
          <div v-for="chapter in chapters" :key="chapter.id">
            <router-link :to="`/chapters/${chapter.id}`">
              <button type="button" class="buton btn" style="margin-bottom: 5px;">
                {{chapter.name}}
              </button>
            </router-link>
          </div>
        </vue-custom-scrollbar>

        <hr>
        <div>
          <button
            type="button"
            class="buton btn"
            @click="$router.go(-1)">
            Înapoi
          </button>
        </div>
    </div>
  </body>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'Class',

  data: () => ({
    chapters: [],
    settings: {
      maxScrollbarLength: 60
    }
  }),

  components: {
    vueCustomScrollbar
  },

  methods: {
    ...mapActions({
      sessionExpired: 'auth/sessionExpired'
    })
  },

  mounted () {
    axios.get(`/classes/${this.$route.params.class}`).then(response => {
      this.chapters = response.data
    }).catch((e) => {
      if(e.response.status == 401){
        this.sessionExpired()
        alert('Sesiunea a expirat. Te rugăm să te autentifici din nou.')
        this.$router.replace({ name: 'login' })
      }
    })
  }
}
</script>

<style scoped>
.body {
 background-color: #FBEFDA;
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 80%;
  height: fit-content;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: fit-content;
}
</style>
